// import { createStore } from 'vuex'

// export default createStore({
//   state: {
//     props : undefined,
//     name: ''
//   },
//   getters: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })



import { createStore } from 'vuex';

// My custom modules
import placesModule from './places';
import { PlacesState } from './places/state';
import mapsModule from './maps'
import { MapState } from './maps/state';


export interface StateInterface {
  // Define your own store structure, using submodules if needed
  // example: ExampleStateInterface;
  // Declared as unknown to avoid linting issue. Best to strongly type as per the line above.
  // example: ExampleStateInterface
  places: PlacesState,
  maps: MapState
}

export default createStore<StateInterface>({
  modules: {
    // example: exampleModule
    places:placesModule,
    maps: mapsModule
  }
})